import './style/about-us.scss'
import './style/r&d-team.scss'
import './style/social-services.scss'
import './style/scientific-production.scss'

(async()=>{
  const { Swiper } = await import(/* webpackChunkName: "swiper" */ 'swiper')

  var swiper = new Swiper('#swiper', {
    direction: 'horizontal', // 垂直切换选项
    on: {
      slideChangeTransitionEnd: function () {
        $('.development-history-tab li').eq(this.realIndex).children('img').attr('src', 'https://static.qifeizn.com/resources/os/images/rod-blue.png');
        $('.development-history-tab li').eq(this.realIndex).siblings().children('img').attr('src', 'https://static.qifeizn.com/resources/os/images/rod-gray.png')
      }
    }
  });


  $('.development-history-tab li').hover(function () {
    swiper.slideTo($(this).index(), 500, false);
    $(this).children('img').attr('src', 'https://static.qifeizn.com/resources/os/images/rod-blue.png');
    //$('.development-history-tab li img').siblings().attr('src','file:///D:/agruav/src/images/rod-gray.png')
    $(this).siblings().children('img').attr('src', 'https://static.qifeizn.com/resources/os/images/rod-gray.png')
  
  });
  swiper.slideTo(4);
})()



$('.about-us-video .watch-video').click(function () {
  $('.about-us-video .video-mask').show()
  $('.about-us-video .video-mask video').attr('src', 'https://static.qifeizn.com/resources/os/videos/qf-xcp.mp4');
})
$('.about-us-video .video-close').click(function () {
  $('.about-us-video .video-mask').hide()
  $('.about-us-video .video-mask video').attr('src', '');
})



